import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import Tabs from '@lendi-ui/tabs';

export const Container = styled.div`
  position: relative;
  z-index: 1;
  background-color: ${() => getColour('background', 'container')};
`;

export const FullWidthTab = styled(Tabs.Tab)`
  width: stretch;
`;
